<script setup lang="ts">
import { IconButton } from '@laam/ui/base';
import { PhArrowUp } from '@phosphor-icons/vue';
const scrollPosition = ref(0);
const scrollToTop = () => {
	window.scrollTo(0, 0);
};
const onScroll = () => {
	scrollPosition.value = window.scrollY;
};
onMounted(() => {
	window.addEventListener('scroll', onScroll);
});

onUnmounted(() => {
	window.removeEventListener('scroll', onScroll);
});

const showButton = computed(() => {
	const y = scrollPosition.value;
	return y > 1600;
});
</script>
<template>
	<IconButton
		v-if="showButton"
		class="fixed bottom-13xl right-7xl"
		size="lg"
		rounded="full"
		variant="secondary"
		@click="scrollToTop"
	>
		<PhArrowUp size="44" />
	</IconButton>
</template>
